import sentimentVeryHappySvg from "./sentimentVeryHappyIcon.svg"

export const sentimentVeryHappyIcon = sentimentVeryHappySvg
